import { Component, ReactNode } from 'react'
import { ModalNode, ModalNodeProps } from '../../../../components/modal.component'
import { appEventEmitter } from '../../../../../initialization'
import { APP_EVENTS } from '../../../../../constants'
import { AddressDetail, AddressDetailProps } from './address-detail'
import { AddressType, AddressTypeLabel, CustomerAddressDto } from '../../../../../definition'
import { asyncDeleteCustomerAddress, asyncGetCustomerAddress } from '../../../../../services'
import { ConfirmModalData } from '../../../../components/confirm-modal.component'
import { toast } from 'react-toastify'

export interface AddressListProps {
  addressList: CustomerAddressDto[]
  addressType: AddressType
  accountId?: string
  refreshData?: () => void
  selectOnly?: boolean
  setSelectAddress?: (address: CustomerAddressDto, addressType: AddressType, index?: number) => void
  bookingAddress?: CustomerAddressDto
  regetDefaultAddress?: (accountId: string, addressType: AddressType) => void
}

export class AddressList extends Component<
  ModalNodeProps<AddressListProps>,
  {
    addresses: CustomerAddressDto[] | []
  }
> {
  componentDidMount() {
    this.fetchAddressList()
  }

  fetchAddressList = async () => {
    if (!this.props.input?.addressType) return
    const data = await asyncGetCustomerAddress(
      { limit: 20, offset: 0 },
      this.props.input?.addressType,
      this.props.input?.accountId || ''
    )
    this.setState({
      addresses: data?.items || []
    })
  }

  onEditAddress = (address: CustomerAddressDto) => {
    appEventEmitter.emit<ModalNode<AddressDetailProps>>(APP_EVENTS.app_modal, {
      status: true,
      node: AddressDetail,
      input: {
        isNew: false,
        address,
        addressType: this.props.input?.addressType,
        accountId: address.accountId
      },
      title: 'Edit Address',
      onClose: () => {},
      onDone: (address: CustomerAddressDto) => {
        this.fetchAddressList()
        if (this.props.input?.accountId) {
          if (this.props.input?.bookingAddress?.id === address.id) {
            this.props.input?.setSelectAddress?.(address, address.addressType)
          }
        }
      }
    })
  }

  onCreateNewAddress = () => {
    appEventEmitter.emit<ModalNode<AddressDetailProps>>(APP_EVENTS.app_modal, {
      status: true,
      node: AddressDetail,
      title: 'Create New Address',
      input: {
        isNew: true,
        addressType: this.props.input?.addressType,
        accountId: this.props.input?.accountId,
        isFirstAddress: this.props.input?.addressList.length === 0
      },
      onClose: () => {},
      onDone: async () => {
        await this.fetchAddressList()
        if (this.props.input?.accountId && this.state.addresses.length === 0) {
          this.props.input?.regetDefaultAddress?.(this.props.input.accountId, this.props.input.addressType)
        }
      }
    })
  }

  onDeleteAddress = (addressId: string) => {
    appEventEmitter.emit<ConfirmModalData>(APP_EVENTS.app_confirm_modal, {
      title: (
        <>
          Are you sure you want to delete this address?
          <br />
          Once deleted it cannot be undone.
        </>
      ),
      onOK: async () => {
        try {
          await asyncDeleteCustomerAddress(addressId)
          await this.fetchAddressList()
          if (this.props.input?.accountId) {
            if (this.props.input?.bookingAddress?.id === addressId) {
              this.props.input?.regetDefaultAddress?.(this.props.input.accountId, this.props.input.addressType)
            }
          }
          toast.success('Success delete')
        } catch (error: any) {
          let errorMessage =
            error?.response?.status >= 500 ? (
              <>
                Can not process the deletion!.
                <br />
                Maybe service have the related data, so we can not delete it.
                <br />
                Please contact with admin developer for get more detail!
              </>
            ) : (
              error.response?.data?.error?.message || error.message
            )
          toast.error(errorMessage)
        }
      }
    })
  }

  render(): ReactNode {
    const state = this.state || {}
    return (
      <div className='customer-address-list-modal'>
        {(state.addresses || []).map((address) => {
          return (
            <div className='customer-address-general'>
              {address.isPrimary && <div className='customer-address-general__primarylabel'>Primary</div>}
              <div className='customer-address-general__content'>
                <label>Address Name</label>: <span>{address.addressName}</span>
                <p>{address.addressLine1}</p>
                <p>{address.unitNo}</p>
                <p>
                  {address.addressCity ? `${address.addressCity},` : null}{' '}
                  {address.addressCountry ? `${address.addressCountry},` : null} {address.addressPostalCode}
                </p>
                <p>Residential Type: {address.residentialType}</p>
              </div>
              {this.props.input?.selectOnly ? (
                <div className='customer-address-general__action'>
                  <button
                    className='customer-address-general__action--edit'
                    onClick={() => {
                      this.props.input?.setSelectAddress?.(address, address.addressType)
                      this.props.onClose?.()
                      toast.success(`Change Designated Address to ${address.addressName}`)
                    }}
                  >
                    Select
                  </button>
                </div>
              ) : (
                <div className='customer-address-general__action'>
                  <button
                    className='customer-address-general__action--del'
                    onClick={() => this.onDeleteAddress(address.id)}
                  >
                    Delete
                  </button>
                  <button
                    className='customer-address-general__action--edit'
                    onClick={() => this.onEditAddress(address)}
                  >
                    Edit
                  </button>
                </div>
              )}
            </div>
          )
        })}
        <div className='customer-address-list-modal-addnew'>
          <button onClick={() => this.onCreateNewAddress()}>
            Add {this.props.input?.addressType && AddressTypeLabel[this.props.input?.addressType]} Address
          </button>
        </div>
      </div>
    )
  }
}
